export default object => ({
  id: object.id,
  reference: `LI-${object.id}`,
  status: object.status,
  name: object.name,
  telephone: object.telephone,
});
